import { render, staticRenderFns } from "./RescheduleMainView.vue?vue&type=template&id=5af5c0d2"
import script from "./RescheduleMainView.vue?vue&type=script&lang=js"
export * from "./RescheduleMainView.vue?vue&type=script&lang=js"
import style0 from "./RescheduleMainView.vue?vue&type=style&index=0&id=5af5c0d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports